import { $window, $body } from '../Constants';
import SwiperSlider from './SwiperSlider';

/**
 * Product Slider
 */
const ProductSlider = (() => {
	/**
	 * Selector
	 *
	 * @var { Object }
	 */
	const Selector = {
		PRODUCT_SLIDER: '.product-slider .swiper-container'
	};

	/**
	 * Product Slider
	 *
	 * @class
	 * @augments SwiperSlider
	 */
	class ProductSlider extends SwiperSlider {
		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			super.onReady();
			this.numberOfSlides = this.$element.find('.swiper-slide:not([class*="hide"])').length;

			console.log(this.numberOfSlides);

			this.setOptions({
				spaceBetween: 30,
				watchOverflow: true,
				loop: this.numberOfSlides >= 5,
				loopedSlides: 5,
				grabCursor: true,
				roundLengths: true,
				centeredSlides: this.numberOfSlides >= 5,
				pagination: {
					el: this.constructor.Selector.PAGINATION,
					clickable: true
				},
				autoplay: {
					delay: 3000,
					disableOnInteraction: false
				},
				centerInsufficientSlides: true,
				breakpointsInverse: true,
				breakpoints: {
					0: {
						slidesPerView: 1
					},
					640: {
						slidesPerView: 'auto'
					}
				}
			});

			this._initialize();
			this._bindHandlers();
		}

		/**
		 * Binds the event handlers to the elements
		 *
		 * @return void
		 */
		_bindHandlers() {
			this.slider.el.addEventListener('mouseenter', () => {
				this.slider.autoplay.stop();
			});

			this.slider.el.addEventListener('mouseleave', () => {
				this.slider.autoplay.start();
			});
		}
	}

	return ProductSlider._getElements(Selector.PRODUCT_SLIDER, ProductSlider);
})();

export default ProductSlider;
